import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { TablaHistorial } from "../gestionAuditoria/Menus/TablaHistorial";
import { Box, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { getTrackingNotaPresupuesto } from "../../../actions/autorizaciones/Autorizaciones";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export const ModalHistorialNotas = (props) => {
  const dispatch = useDispatch();
  const { open } = props;

  const { trackingNotas } = useSelector((state) => state.autorizaciones);


  useEffect(() => {
    dispatch(getTrackingNotaPresupuesto(props.nota?.idNota));
  }, []);

  return (
    <Dialog
      fullWidth
      maxWidth={"md" /*"lg"*/}
      open={open}
      onClose={props.closeModalHandler}
    >
      <DialogTitle>Historial de Cambios - {props.titulo}</DialogTitle>
      <DialogContent>
        <TablaHistorial datos={trackingNotas} />
      </DialogContent>
    </Dialog>
  );
};
